<template>
  <div>
    <Sidebar
      class="p-sidebar-md custom-sidebar"
      :dismissable="true"
      position="right"
      :visible.sync="localShowSidebar"
      @hide="close"
      :style="{ width: '500px' }"
    >
      <ConfirmDialog group="sidebarStatusControlConfirmDialog" />
      <div class="sidebar-header p-mb-3">
        <h3><i class="pi pi-list p-mr-2"></i>Controlo de Estados PATs</h3>
        <div class="p-d-flex p-jc-between p-ai-center">
          <div>
            <span class="p-text-secondary" v-if="tasks.length">
              {{ tasks.length }} intervenções recentes por confirmar
            </span>
          </div>
          <div>
            <Button
              label="Ir para a lista completa"
              class="p-button-info"
              icon="pi pi-table"
              @click="goToAllStatusControlPats"
            />
          </div>
        </div>
      </div>


      <div v-if="loading" class="p-d-flex p-ai-center p-jc-center" style="height: 200px">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
      </div>

      <div v-else class="route-content">
        <div v-for="task in tasks" :key="task.id" class="tech-route-container p-mb-3">

          <div class="tech-header p-p-2 p-d-flex p-ai-center p-jc-between">
            <div class="p-d-flex p-ai-center p-cursor-pointer" @click="goToPat(task.pat_id)">
              <i class="pi pi-external-link p-mr-2" v-tooltip.top="'Abrir PAT'"></i>
              <strong class="p-mr-2">PAT #{{ task.pat_id }}</strong> - {{ task.pat_equipment_brand || '-' }}
            </div>
          </div>

          <div class="timeline-container p-mt-2">
            <div class="timeline-item">
              <div class="content-col p-shadow-1">
                <div class="p-d-flex p-jc-between p-mb-1">
                  <span class="p-badge p-component p-ml-2"
                    :style="{
                        backgroundColor: task.old_status_color,
                        color: getReadableTextColor(task.old_status_color)
                      }">
                      {{ task.old_status || '-' }}
                  </span>
                  <i class="pi pi-arrow-right p-mx-2"></i>
                  <span class="p-badge p-component p-ml-2"
                    :style="{
                        backgroundColor: task.status_color,
                        color: getReadableTextColor(task.status_color)
                      }">
                    {{ task.status || '-' }}
                  </span>
                </div>

                <Accordion>
                  <AccordionTab header="Detalhes">
                    <div class="client-name">
                      <p class="m-0">
                        Tarefa ID: {{ task.task_id || '-' }} <br>
                        Início deslocação: {{ task.task_init_hour || '-' }} <br>
                        Check-in: {{ task.task_check_in || '-' }} <br>
                        Check-out: {{ task.task_check_out || '-' }} <br>
                        Data: {{ formatDate(task.created_at) }}<br>
                        Problema: {{ task.pat_problem || '-' }}<br>
                        Resumo: {{ task.pat_resume || '-' }}<br>
                      </p>
                    </div>
                  </AccordionTab>
                </Accordion>
              </div>

              <div class="divider-col">
                <Button
                  v-if="!task.confirmed_at"
                  icon="pi pi-check"
                  class="p-button-rounded p-button-success p-button"
                  v-tooltip.top="'Confirmar Alteração de Estado'"
                  @click="askForConfirm(task)"
                />
              </div>
            </div>
          </div>
        </div>

        <div v-if="tasks.length === 0" class="p-text-center p-p-4">
          Nada a mostrar.
        </div>
      </div>
    </Sidebar>
  </div>
</template>

<script>
import chroma from "chroma-js";
import Sidebar from "primevue/sidebar";
import technicalManagementService from '@/services/technical-management.service';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import ConfirmDialog from "primevue/confirmdialog";
import { mapGetters, mapActions } from 'vuex';

export default {
  name: "SidebarStatusControlPatIndicator",
  components: { Sidebar, Accordion, AccordionTab, ConfirmDialog },
  data() {
    return {
      loading: false,
      localShowSidebar: false,
    };
  },
  computed: {
    ...mapGetters('technicalManagement', [
        'listStatusControl',
        'showSidebarStatusControlPatIndicator'
    ]),
    tasks() {
      return this.listStatusControl || [];
    }
  },
  watch: {
    showSidebarStatusControlPatIndicator(newVal) {
      this.localShowSidebar = newVal;
    }
  },
  methods: {
    ...mapActions('technicalManagement', {
      fetchStatusControl: 'fetchStatusControl',
      toggleSidebarStatusControl: 'toggleSidebarStatusControl'
    }),
    close() {
      this.toggleSidebarStatusControl(false);
    },
    getStatusClass(status) {
      if (status === 'PRONTO') return 'status-ready';
      return 'status-default';
    },
    askForConfirm(row) {
      this.$confirm.require({
        group: 'sidebarStatusControlConfirmDialog',
        message: `Tem a certeza que deseja confirmar o estado do PAT ${row.pat_id}?`,
        header: 'Confirmação de Estado',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: async () => await this.confirm(row),
        reject: () => {
            return;
        },
      });
    },

    async confirm(row) {
      try {
        this.loading = true;

        const response = await technicalManagementService.confirmPatStatusControl(row.id);
        if (response.status === 'success') {
            this.$toast.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: 'Estado confirmado com sucesso',
                life: 3000
            });

            await this.fetchStatusControl();
        } else {
            this.$toast.add({
                severity: 'error',
                summary: 'Erro',
                detail: response.message || 'Erro ao confirmar estado',
                life: 3000
            });
        }

    } catch (error) {
        this.$toast.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Erro ao carregar controlo de estados',
            life: 3000
        });
    } finally {
        this.loading = false;
    }
    },

    goToPat(patId) {
      this.$router.push(`/pats/${patId}`);
    },

    goToAllStatusControlPats() {
      this.$router.push('/status-control-pats');
      this.close();
    },

    formatDate(dateString) {
      if (!dateString) return '-';

      const date = new Date(dateString);
      return date.toLocaleDateString('pt-PT', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
      });
    },
    getReadableTextColor(backgroundColor) {
      const whiteContrast = chroma.contrast(backgroundColor, "#ffffff");
      const blackContrast = chroma.contrast(backgroundColor, "#000000");
      return whiteContrast > blackContrast ? "#ffffff" : "#000000";
    },
  },
};
</script>

<style scoped>
.sidebar-header { border-bottom: 1px solid #e0e0e0; padding: 1.5rem 1.5rem 1rem 1.5rem; }
.route-content { padding: 1rem; }

.tech-route-container { border: 1px solid #e2e8f0; border-radius: 8px; overflow: hidden; background: white; }
.tech-header { background-color: #f8fafc; border-bottom: 1px solid #e2e8f0; }
.tech-name { font-weight: 700; color: #334155; font-size: 0.9rem; }
.route-time-span { font-size: 0.85rem; background: #e2e8f0; padding: 2px 8px; border-radius: 4px; }

.timeline-container { padding: 0 1rem 0.5rem 1rem; }
.timeline-item { display: flex; }
.divider-col[data-v-5a589b6a] { width: 50px; display: flex; justify-content: center; margin: auto 5px; }
.dot { width: 10px; height: 10px; background-color: #3b82f6; border-radius: 50%; }

.content-col { flex: 1; margin-left: 10px; margin-bottom: 10px; padding: 10px; border-radius: 6px; }
.pat-status { font-size: 0.87rem; font-weight: bold; padding: 2px 6px; border-radius: 4px; background: #eee; }
.status-ready { background: #dcfce7; color: #166534; }

.client-name { font-weight: 600; font-size: 0.94rem; margin: 4px 0; color: #1e293b; }
.pat-address { font-size: 0.8rem; color: #64748b; white-space: pre-line; }

.p-cursor-pointer { cursor: pointer; }

.custom-sidebar .p-sidebar-content { padding: 0 !important; z-index: 1100 !important; }
</style>